import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <rect width={16} height={16} fill="#D9D9D9" rx={6} />
    <path
      fill="#4D4D4D"
      d="m12.842 4.092-2.684 1.633-1.633-1.692c-.117-.116-.35-.175-.525-.175-.175 0-.408.059-.525.175L5.842 5.725 3.158 4.092c-.466-.292-1.108.116-.991.641l1.925 7c.058.234.35.409.641.409h6.534c.291 0 .583-.175.641-.409l1.925-7c.117-.525-.525-.933-.991-.641Zm-3.092 5.95h-3.5a.46.46 0 0 1-.467-.467c0-.292.175-.467.467-.467h3.5a.46.46 0 0 1 .467.467.46.46 0 0 1-.467.467Z"
    />
  </svg>
);
export default SvgComponent;
